<template>
  <router-link
    :to="to"
    :class="classes"
    class="ocean-ui-vlink"
    :tag="tag"
    :replace="replace"
    :append="append"
    :style="styles"
  >
    <slot></slot>
  </router-link>
</template>
<script>
import themeMixins from '../../mixins/themeMixins';
let colorDefault = '#fff';
export default {
  name: 'Vlink',
  mixins: [themeMixins],
  props: ['to', 'replace', 'append', 'tag', 'decoration', 'type', 'disabled'],
  computed: {
    classes() {
      let type = this.type || 'default';
      let classes = [`ocean-ui-vlink-${type}`];
      if (this.active) {
        classes.push(`${this.oceanuiClassName}-${type}-active`);
      }
      return classes;
    },
    styles() {
      let styles = {};
      if (this.decoration !== undefined) {
        styles['text-decoration'] = 'undeline';
      } else {
        styles['text-decoration'] = 'none';
      }
      if (this.disabled !== undefined) {
        styles['cursor'] = 'not-allowed';
      }
      return styles;
    },
  },
};
</script>
<style scope>
.ocean-ui-vlink {
  text-decoration: none;
  cursor: pointer;
}
.ocean-ui-vlink:active {
  opacity: 0.8;
}
.ocean-ui-vlink-default {
  color: #fff;
}
.ocean-ui-vlink-default:hover {
  color: #409eff;
}

.ocean-ui-vlink-primary {
  color: #409eff;
}
.ocean-ui-vlink-primary:hover {
  text-decoration: underline;
}

.ocean-ui-vlink-success {
  color: #67c23a;
}
.ocean-ui-vlink-success:hover {
  text-decoration: underline;
}

.ocean-ui-vlink-warning {
  color: #e6a23c;
}
.ocean-ui-vlink-warning:hover {
  text-decoration: underline;
}

.ocean-ui-vlink-danger {
  color: #f56c6c;
}
.ocean-ui-vlink-danger:hover {
  text-decoration: underline;
}

.ocean-ui-vlink-info {
  color: #909399;
}
.ocean-ui-vlink-info:hover {
  text-decoration: underline;
}
</style>
